import { Badge } from '@/components/ui/badge';
import type { QuoteStatus } from '@/types/billing';

const STATUS_CONFIG: Record<QuoteStatus, { label: string; className: string }> = {
  draft: { label: 'Borrador', className: 'bg-gray-100 text-gray-800 border-gray-200' },
  sent: { label: 'Enviado', className: 'bg-blue-100 text-blue-800 border-blue-200' },
  accepted: { label: 'Aceptado', className: 'bg-green-100 text-green-800 border-green-200' },
  rejected: { label: 'Rechazado', className: 'bg-red-100 text-red-800 border-red-200' },
  expired: { label: 'Expirado', className: 'bg-orange-100 text-orange-800 border-orange-200' },
  invoiced: { label: 'Facturado', className: 'bg-purple-100 text-purple-800 border-purple-200' },
  partially_paid: { label: 'Pago parcial', className: 'bg-yellow-100 text-yellow-800 border-yellow-200' },
  paid: { label: 'Pagado', className: 'bg-emerald-100 text-emerald-800 border-emerald-200' },
  cancelled: { label: 'Cancelado', className: 'bg-gray-100 text-gray-600 border-gray-200' },
};

interface QuoteStatusBadgeProps {
  status: QuoteStatus;
}

export function QuoteStatusBadge({ status }: QuoteStatusBadgeProps) {
  const config = STATUS_CONFIG[status];
  return (
    <Badge variant="outline" className={config.className}>
      {config.label}
    </Badge>
  );
}
